import { ref } from "vue";
import { watch } from "vue";
import { computed } from "vue";
import { useStore } from "vuex";
import { onMounted } from "vue";
import { useRouter } from "vue-router";

import { CompanyListState } from "@/modules/company-lists/services/store/company-list/company-list.modules";

export const useCompanyList = () => {
  const store = useStore();
  const router = useRouter();

  const lists = computed(() => store.state.companyList.values);
  const selectedList = ref();
  const emptyOrNoList = computed(() => {
    // returns true if either there is no list
    // present or there are no companies in
    // the currently selected list
    if (selectedList.value) {
      const list = lists.value.filter(
        (list: any) => list.uid === selectedList.value,
      )?.[0];

      if (list && list.companies?.length <= 0) {
        return true;
      }
    } else {
      if (lists.value.length <= 0) {
        return true;
      }
    }

    return false;
  });

  const gotoSelectedList = () => {
    router.push(`/lists/${selectedList.value}`);
  };

  const gotoListCreationPage = () => {};

  watch(lists, () => {
    if (lists.value?.length) {
      selectedList.value = lists.value[0].uid;
    }
  });

  onMounted(() => {
    store.dispatch(CompanyListState.Action.GET_VALUES);
  });

  return {
    lists: lists,
    emptyOrNoList,
    selectedList: selectedList,
    gotoSelectedList,
    gotoListCreationPage,
  };
};
